"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyKlarna = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.NotifyKlarna = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.notify_klarna.label',
    fallbackLabel: 'Could you please confirm that Klarna will be notified in the event of a change to your Partner Bank or if you obtain your own financial license without due delay?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_entity_answers.licensing', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.mor_entity_answers?.licensing?.valueOf?.() === 'PARTNERED_LICENSED_ENTITY' || payload.mor_entity_answers?.licensing?.valueOf?.() === 'HOLDS_VALID_LICENSE_AND_LICENSED_PARTNER_IN_OTHER_REGIONS')
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.mor_entity_answers?.licensing?.valueOf?.() === 'PARTNERED_LICENSED_ENTITY' || payload.mor_entity_answers?.licensing?.valueOf?.() === 'HOLDS_VALID_LICENSE_AND_LICENSED_PARTNER_IN_OTHER_REGIONS')
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
